import { render, staticRenderFns } from "./ServiceSearchResultHeader.vue?vue&type=template&id=ca6659d0"
import script from "./ServiceSearchResultHeader.vue?vue&type=script&lang=js"
export * from "./ServiceSearchResultHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports